module.exports = __webpack_public_path__ + "static/img/2.ff03f6d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/2.png
// module id = oUjK
// module chunks = 1